import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import {
  setActiveStep,
  setShowForm,
  setSolicitud,
} from "../../../actions/autorizaciones/Autorizaciones";

import {
  STEPPER_AUTORIZACIONES,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
} from "../../../utils/constants";
import IconEstado from "../UI/IconEstado";
import { AutorizacionesConsumoPractica } from "./AutorizacionesConsumoPractica";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const AutorizacionesConsumoItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { afiliadoSeleccionado } = useSelector((state) => state.autorizaciones);

  const [openPracticaInfo, setOpenPracticaInfo] = useState(false);

  const { solicitud } = props;

  const onClickSolicitudHandler = (solicitud) => {
    dispatch(setSolicitud(solicitud));
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
    // dispatch(setShowForm(false));
    dispatch(setShowForm(true)); //Mostrar la pantalla de tipo auth
  };

  return (
    <React.Fragment>
      <TableRow className={classes.iconEstado}>
        <TableCell>
          <IconEstado
            useColorTable={true}
            texto={solicitud?.estadosSolicitud?.letra}
            backgroundColor={solicitud?.estadosSolicitud?.color}
            descripcion={solicitud?.estadosSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell>{solicitud?.idSolicitud}</TableCell>
        <TableCell>
          {new Date(solicitud?.fecha).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{solicitud?.tipoSolicitud?.descripcionTipo}</TableCell>
        <TableCell align="left">{solicitud?.conInternacion ? 'SI' : 'NO'}</TableCell>
        <TableCell>
          {solicitud?.practicas?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() =>
                setOpenPracticaInfo(
                  (prevOpenPracticaInfo) => !prevOpenPracticaInfo
                )
              }
            >
              {openPracticaInfo ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          )}
        </TableCell>
        <TableCell>{solicitud?.diagnostico?.problema}</TableCell>
        <TableCell>
          {(solicitud?.estadosSolicitud?.idEstado ===
            AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA || 
            solicitud?.estadosSolicitud?.idEstado ===
            AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION) && (
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                onClickSolicitudHandler(solicitud);
              }}
              disabled={afiliadoSeleccionado?.fecha_baja}
            >
              Ir a Solicitud
            </Button>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            paddingLeft: 50,
          }}
          colSpan={8}
        >
          <Collapse in={openPracticaInfo} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Práctica</TableCell>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell>Materiales</TableCell>
                    <TableCell>Institucion</TableCell>
                    <TableCell>Profesional</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(solicitud?.practicas) &&
                    solicitud?.practicas?.length > 0 &&
                    solicitud?.practicas?.map((practica) => (
                      <AutorizacionesConsumoPractica
                        key={practica?.idCodNom}
                        practica={practica}
                      />
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
